import ViewBase from '../../../view-base.view';
import udfManagementModel from '../../../../models/udf-management/udf-management.modal';
import TableComponent from '../../../../components/common/table.component';

export default function UserDetailsUdfView() {
  ViewBase.call(this);

  let _udfData = [];

  const setCountryList = (userId) => {
    udfManagementModel.getMapData(
      (result) => {
        _udfData = result ?? [];
      }, (error) => {
        _udfData = [];
      },
      { udfType: 'user', countryCode: 'all', mapData: userId }
    );
  }

  return {
    oninit: function ({ attrs }) {
      setCountryList(attrs.userId);
    },
    view: () => {
      return [
        m("div", { "class": "card mb-3 searchbox no-leftradius" },
          m("div", { "class": "card-body py-4" },
            m('.row .justify-content-center',
              m('.col-md-12',
                m('form',
                  m('.row .mb-3 small', m('h3', this.getText("LT00000008", "UDF Management"))),
                  m('div', { "class": "card no-leftradius" },
                    m(TableComponent, {
                      isNested: false,
                      headers: [
                        { label: this.getText("LT00000188", "Country") },
                        { label: this.getText("LT00000262", "UDF Attribute") },
                        { label: this.getText("LT00000263", "UDF Value") },
                        { label: this.getText("LT00000273", "Create By") },
                        { label: this.getText("LT00000274", "Update By") },
                      ],
                      details: _udfData.map(d => [
                        m("tr",
                          m("td", { "style": { "max-width": "150px", "white-space": "initial" } }, d.countryName),
                          m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.attributeName),
                          m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.valueName),
                          m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.createUserId),
                          m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.updateUserId),
                        )
                      ]),
                    })
                  )
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
